module.exports = __webpack_public_path__ + "img/login-logo.2f630c22.png";